export const convertToRem = (px: number, base = 16): string => `${px / base}rem`;